// export const baseUrl = "http://localhost:5000/admin/";
export const baseUrl = "https://yamac-backend.vercel.app/admin/";
